import { AxiosProgressEvent } from "axios";

import { fetcher } from "helpers/fetcher";

import { TAddStaffCardReq, TFileUploadRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addStaffIdCard = async (
  payload: TAddStaffCardReq,
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
  return await fetcher<TFileUploadRes, TAddStaffCardReq["data"]>(
    ENDPOINT.USER.ADD_STAFF_ID_CARD,
    {
      data: payload.data,
      fileFields: ["file"],
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_STAFF_ID_CARD.version,
        [API_HEADER.USER_ID]: payload.idUser,
      },
      onUploadProgress: (progressEvent) => {
        if (onUploadProgress) onUploadProgress(progressEvent);
      },
    }
  );
};
